"use client";

import React from "react";
import { Tooltip, Tag } from "@/ui";
import { colors, spacing, textStyles } from "@/ui/tokens";
import { Info } from "@mui/icons-material";
import { motion } from "framer-motion";
import type { SolaUsage } from "@/lib/sola/types";

interface UsageDisplayProps {
  usage?: SolaUsage;
  className?: string;
}

export function UsageDisplay({ usage, className }: UsageDisplayProps) {
  if (!usage) return null;

  const formatTime = (timestamp: string) => {
    try {
      return new Date(timestamp).toLocaleTimeString();
    } catch {
      return "Unknown";
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className={className}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: spacing[2],
          justifyContent: "center",
          marginTop: spacing[2],
        }}
      >
        <Tooltip
          content={
            <div>
              <span style={{ ...textStyles.caption, display: "block" }}>
                Prompt tokens: {usage.promptTokens}
              </span>
              <span style={{ ...textStyles.caption, display: "block" }}>
                Completion tokens: {usage.completionTokens}
              </span>
              <span style={{ ...textStyles.caption, display: "block" }}>
                Total tokens: {usage.totalTokens}
              </span>
              <span style={{ ...textStyles.caption, display: "block" }}>
                Last updated: {formatTime(usage.timestamp)}
              </span>
            </div>
          }
        >
          <Tag
            variant="default"
            size="sm"
            icon={<Info style={{ fontSize: 14 }} />}
          >
            {usage.totalTokens} tokens
          </Tag>
        </Tooltip>

        <span
          style={{
            ...textStyles.caption,
            color: colors.text.muted,
          }}
        >
          Updated: {formatTime(usage.timestamp)}
        </span>
      </div>
    </motion.div>
  );
}
